import { showToast } from '@/components/Toast'

import config from '@/config'
import useCenter from '@/lib/useMapCenter'
import { useMobile } from '@/lib/useMedia'
import type { Language } from '@/types'

let currentPosition: google.maps.LatLngLiteral | null = null
let loadingLocation = false

const { updateCenter } = useCenter()
const isMobile = useMobile()

const useCurrentUserLocation = (
  map: google.maps.Map | undefined,
  message: string,
  lang: Language,
): void => {
  if (loadingLocation) return
  loadingLocation = true

  if (currentPosition?.lat && currentPosition?.lng) {
    map?.panTo(currentPosition)
  }

  if (!navigator.geolocation) {
    return
  }

  navigator.geolocation.getCurrentPosition(
    (positon) => {
      currentPosition = {
        lat: positon.coords.latitude,
        lng: positon.coords.longitude,
      }
      new google.maps.Marker({
        label: '',
        position: currentPosition,
        map,
      })

      updateCenter(currentPosition)
      map?.panTo(currentPosition)
      map?.setZoom(
        config.settings[lang][isMobile.value ? 'mobile' : 'desktop']
          .defaultZoom,
      )
    },
    () => {
      showToast(message, 10000)
      loadingLocation = false
    },
  )

  loadingLocation = false
}

export default useCurrentUserLocation
